<template>
  <teleport to="#modals">
    <div
      v-show="show"
      class="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-show="show"
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true"
          ></div>
        </transition>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            v-show="show"
            :class="maxWidthStyling"
            class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:p-6"
          >
            <div
              v-if="closeable"
              class="block absolute top-0 right-0 pt-4 pr-4"
            >
              <button
                @click="close()"
                type="button"
                class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500"
              >
                <XIcon class="h-6 w-6" />
              </button>
            </div>
            <slot />
          </div>
        </transition>
      </div>
    </div>
  </teleport>
</template>

<script>
import { onMounted, onUnmounted } from "vue";
import { XIcon } from "@heroicons/vue/outline";

export default {
  emits: ["close"],
  name: "UiModal",
  props: {
    show: {
      default: false,
    },
    maxWidthStyling: {
      default: "sm:max-w-lg",
    },
    closeable: {
      default: true,
    },
  },

  components: {
    XIcon,
  },

  watch: {
    show: {
      immediate: true,
      handler: (show) => {
        if (show) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = null;
        }
      },
    },
  },

  setup(props, { emit }) {
    const close = () => {
      if (props.closeable) {
        emit("close");
      }
    };

    const closeOnEscape = (e) => {
      if (e.key === "Escape" && props.show) {
        close();
      }
    };

    onMounted(() => document.addEventListener("keydown", closeOnEscape));
    onUnmounted(() => document.removeEventListener("keydown", closeOnEscape));

    return {
      close,
    };
  },
};
</script>